<template>
  <v-content>
    <TaskDialog ref="dialog" />

    <v-card class="elevation-0">
      <v-card-text>
        <ORow class="my-4" center-xy>
          <v-spacer/>

          <v-btn icon large @click="prev">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <span class="mx-4">
            {{ startOfMonth | moment('MMMM/YYYY') }}
          </span>

            <v-btn icon @click="reload">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

          <v-btn icon large @click="next">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>

          <v-spacer/>

          <div style="width: 300px; position: relative" class="menu-holder">


            <v-text-field
              class="menu-holder"
              v-model="keywords"
              placeholder="Palavras-chave"
              single-line
              clearable
              append-icon="mdi-menu-down"
              @click:append="showingMenu = !showingMenu"
            />

          </div>

            <Search
              :keywords="keywords"
              :width="600"
              v-model="showingMenu"
              @rowClicked="r => showTask(r.id)"
            />

          <v-spacer/>
        </ORow>

        <OLoadingLine absolute :value="isLoading" />

        <v-calendar
          ref="calendar"
          v-model="startOfMonth"
          color="primary"
          :events="displayEvents"
          :event-color="e => e.color"
          type="month"
          @click:event="v => showTask(v.event.id, v.nativeEvent)"
          @click:day="newTask"
          @change="updateRange"
        >
          <!-- <template v-slot:event="{ event }">
          @click:more="viewDay"
            <div class="px-1 h-row">
              <b>{{ event.start | moment('HH:mm') }}</b>
              {{ event.name }}
              <v-spacer />
              <v-icon x-small color="white">mdi-alert</v-icon>
            </div>
          </template> -->
        </v-calendar>
      </v-card-text>
    </v-card>
  </v-content>
</template>

<script>
import { Task } from '@/models'
import utils from 'oderon-commons/src/utils.js'
import TaskDialog from './TaskDialog.vue'
import moment from 'moment'
// import TheUser from 'oderon-vue/auth/TheUser'
import sample from './sample.json'
import debounce from 'lodash/debounce'
import Search from './Search.vue'

export default {
  pageTitle: 'Tarefas',
  components: {
    TaskDialog,
    Search
  },
  data() {
    return {
      isLoading: false,
      keywords: null,
      tasks: [],
      startOfMonth: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      fromDate: null,
      untilDate: null,

      queryResults: sample,
      loadingQuery: false,
      showingMenu: false,

      debouncedQueryKeywords: debounce(() => this.queryKeywords(), 250)
    }
  },

  computed: {
    hasKeywords() {
      return !utils.isEmpty(this.keywords)
    },

    displayEvents() {
      return this.tasks.map(task => {
        let color = task.color || 'orange'
        if ( !utils.isEmpty(this.keywords) && !utils.matchAnyLike(this.keywords, task.description) ) {
          color += ' dimmed'
        }

        return {
          id: task.id,
          start: moment(task.timestamp).format('YYYY-MM-DD HH:mm'),
          name: task.description,
          color
        }
      })
    },

    apiParams() {
      if (this.fromDate == null) return null

      return {
        fromDate: this.fromDate,
        untilDate: this.untilDate,
        includeInactive: false
      }
    }
  },

  watch: {
    apiParams() {
      this.reload()
    },
    keywords() {
      console.log('debounced query')
      this.debouncedQueryKeywords()
    }
  },

  mounted() {
    this.$refs.calendar.checkChange()
  },

  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      if (this.apiParams == null) return null
      // await this.$delay(2000)
      this.tasks = await Task.findAll(this.apiParams)
    },

    async updateRange({ start, end }) {
      let calendarFrom = this.$refs.calendar.getStartOfWeek(start).date
      let calendarUntil = this.$refs.calendar.getEndOfWeek(end).date

      this.fromDate = utils.sod(calendarFrom)
      this.untilDate = utils.sod(calendarUntil, 1)
    },

    async newTask({ date }) {
      // let now = moment().format('DD/MM/YYYY HH:mm')
      // let login = TheUser.user.login

      let description = await this.$prompt({
        label: 'Descreva esta tarefa:'
        // value: `Criada em ${now} por ${login}`
      })

      if (!utils.isEmpty(description)) {
        let timestamp = moment(date)
          .set('hour', 12)
          .startOf('h')
        if (moment().isSame(timestamp, 'date')) {
          timestamp = moment()
        }

        this.$loading(async () => {
          await Task.save({
            timestamp: timestamp.format(),
            description
          })

          await this.fetchData()
        })
      }
    },

    prev() {
      this.$refs.calendar.prev()
    },

    next() {
      this.$refs.calendar.next()
    },

    async showTask(id, nativeEvent) {
      if ( nativeEvent ) nativeEvent.stopPropagation()
      await this.$refs.dialog.open(id)
      this.reload()
    },

    async queryKeywords() {
      try {
        this.loadingQuery = true
        this.queryResults = await Task.findAll({
          keywords: this.keywords,
          limit: 5,
          order: 'timestamp desc, id desc'
        })
      } finally {
        this.loadingQuery = false
      }
    }
  }
}
</script>

<style lang="sass">
.dimmed
  opacity: .2 !important



</style>
